import React from "react"
import styled from "styled-components"

export const ScrolltopNav = () => {
  const handler = () => {
    window.scroll({ top: 0, behavior: "smooth" })
  }

  return (
    <ScrollTopNavDiv onClick={handler}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_767_2972)">
          <rect
            y="16"
            width="16"
            height="16"
            rx="8"
            transform="rotate(-90 0 16)"
            fill="#242424"
          />
          <path
            d="M5.81836 7.41827L8.00018 5.091M8.00018 5.091L10.182 7.41827M8.00018 5.091V10.9092"
            stroke="#F4F4F4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_767_2972">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="matrix(0 -1 1 0 0 16)"
            />
          </clipPath>
        </defs>
      </svg>
      <span>PAGE TOP</span>
    </ScrollTopNavDiv>
  )
}

const ScrollTopNavDiv = styled.div`
  @media screen and (max-width: 767px) {
    font-size: 16px;
    font-family: futura-pt;
    letter-spacing: 0.1rem;
    display: flex;
    width: max-content;
    flex-direction: row-reverse;
    gap: 8px;
    :hover {
      cursor: pointer;
    }
    span {
      color: var(--Dark_Gray, #242424);
      text-align: center;
      font-feature-settings: "clig" off, "liga" off;
      font-family: Futura PT;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 100% */
      letter-spacing: 1px;
    }
  }
  @media screen and (min-width: 768) {
    display: none;
  }
`
